export default {"gitHash":"8cc34c096839be7e4bf123b1458478131d09ffdc","gitHashShort":"8cc34c0","time":1674702474157,"platform":"linux","arch":"x64"};